import { MatchResponse } from '../dto/response/match.response';

export const getMatchByIdResponseTransformer = (matchResponse: MatchResponse): MatchResponse => {
  matchResponse.networkedTalents = matchResponse.networkedTalents?.filter((networkedTalent) => !!networkedTalent.connectionCompoundScore);

  return matchResponse;
};
